import React from 'react'
import officeImg from "../assets/office.png"
import { useNavigate, Link } from 'react-router-dom'
import "./components.css"

const OrgCard = ({ org }) => {


    const navigate = useNavigate()

    return (
        <div className='org-card'>
            <div className="org-card-body">
                <div className="org-image">
                    <Link to={`/${org.name}/`}>
                        <img src={org?.logo.url ? org.logo.url : officeImg} alt="" />
                    </Link>
                </div>
                <div className="org-info">
                    <h1
                        className="org-name linking"
                        onClick={() => navigate(`/${encodeURIComponent(org?.name)}`, { state: { org } })}
                    >
                        {org?.name}
                    </h1>
                    <div className="org-bio">
                        <p>
                            {org.description.length > 120
                                ? `${org.description.slice(0, 120)}...`
                                : org.description}
                        </p>
                    </div>
                    <div className="org-community">
                        <Link to={`/${org.name}/members/`}>
                            <p>Members{`(${org?.membersCount})`}</p>
                        </Link>
                        <Link to={`/${org.name}/friends/`}>
                            <p>Friends{`(${org?.friendsCount})`}</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgCard